import { useParams } from 'react-router';

import useI18next from 'services/i18n';

import { useArticleQuery } from 'hooks/useArticleQuery';

import { Article, Error, Loader, MarkdownRenderer } from './components';

export const ArticleModule = () => {
    const { articleId } = useParams<{ articleId: string }>();
    const { data: article, isLoading, isError } = useArticleQuery(articleId);
    const { isTranslationsLoaded } = useI18next();

    if (!isTranslationsLoaded) {
        return <Loader />;
    }

    if (isError) {
        return <Error />;
    }

    if (isLoading || !article) {
        return <Loader />;
    }

    return (
        <Article
            image={article.heroImage}
            title={article.title}
            expert={article.expert}
            content={<MarkdownRenderer content={article.content} />}
        />
    );
};
